import React, {Fragment} from 'react';
import {useAuth} from "./AuthProvider";
import {useLocation, Navigate, Outlet} from "react-router-dom";

const AuthGuard = () => {
    let {user} = useAuth();
    let location = useLocation();

    if (!user) {
        return <Navigate to={"/auth/login"} state={{from: location}} replace={true}/>
    }
    return (
        <Fragment>
            <Outlet/>
        </Fragment>
    );
};

export default AuthGuard;